import { provideErrorHandler } from './_services/sentry-error-handler.service';
var ɵ0 = provideErrorHandler;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
